import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EventBean } from '../../../beansts/Event';
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { ActivatedRoute,RouterLink} from '@angular/router';
declare let $: any;
declare var Swal : any;

@Component({
    selector : 'company-register',
    templateUrl:'company-register.html',
})
export class CompanyRegisterComponent implements OnInit, OnDestroy{
  public companyLogo="/assets/fixme/logo.png"
  public companyImage="https://www.macmillandictionary.com/us/external/slideshow/full/Grey_full.png"

  public gender='M';
  public avatars=["h1.png","h2.png","h3.png","h4.png","h5.png","h6.png","h7.png","h8.png"]
  public avatarId=0;
  public basicInfoForm
  public loginInfoForm
  public tab=1;
  public company;
  public thumbnail=""

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _routeParams : ActivatedRoute,public _appData : AppDataService,public translate: TranslationService,private fb : FormBuilder, private _companyService : CompanyService) {

    this.loginInfoForm = this.fb.group({
      userEnterName: '',
      userEnterEmail: '',
      userEnterPassword:'',
      userEnterPassword2:'',
      lgpdOK:''
    });

  }
    public setTab(tab){
      this.tab=tab;
    }
    public setSex(sex){
      this.gender=sex;
    }

    public ngOnInit(): any {
      this.loginInfoForm = this.fb.group({
        userEnterName: '',
        userEnterEmail: '',
        userEnterPassword:'',
        userEnterPassword2:'',
        lgpdOK:''
      });
      this._routeParams.params.subscribe(params => {
        var cid = params.id
        this._companyService.getCompanyById(cid).get().then(v=>{
          this.company=v.data();
          if (typeof window !== "undefined" && localStorage){
            localStorage.setItem('company',JSON.stringify(this.company))
          }
          this.companyImage=this.company.thumbnail
          this.companyLogo=this.company.logo

        })
      });
    }

    public ngOnDestroy() : any {
    }


    public forgetPassword(){
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      if (userEmail==null || userEmail.length==0){
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_11'))
        return;
      }   
      this._companyService.forgetPassword(userEmail).then((val)=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_12'))
      }).catch(err=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_13'))
      }     
        );
    }
    public loginUserData(){
      let domain=window.location.origin
      window.location.replace(domain+"/login/"+this.company.dbId);   

    }
    public registerUserData(){
      let userName : string      = this.loginInfoForm.controls['userEnterName'].value;
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      let userPassword : string = this.loginInfoForm.controls['userEnterPassword'].value;
      let userPassword2 : string = this.loginInfoForm.controls['userEnterPassword2'].value;
      let lgpdOk : string = this.loginInfoForm.controls['lgpdOK'].value;
      if (!userName || userName.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_14'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }

      if (!userEmail || userEmail.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_15'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (userPassword.length<8){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_16'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (userPassword2.length<8){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_17'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }

      if (userPassword2 != userPassword){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_17'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }

      if (!lgpdOk){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: 'Você não aceitou o LGPD. Por favor baixe e aceite para entrar.',
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      this._companyService.registerUser(userEmail,userPassword).then((result) => {
        let uid=result.user.uid;
        console.log('usuario registrado no servidor' +uid)
        let event =this._appData.event;
        if (!event) {
          event=new EventBean();
          event.id=1592880902713
          event.room=this.company.room ? this.company.room : ''
        }

        if (!event.room) event.room=this.company.room ? this.company.room : ''
        if (!event.id) event.id=1592880902713
        let date=new Date();
        let time=date.getTime();
        let user={
            uid: uid,
            full_name:userName,
            email:userEmail,
            sex:'M',
            gender:'male',
            event:event.id.toString(),
            room:event.room,
            avatarVersion:4,
            userPolicyChecked:true,
            userPolicyCheckdTime: time,
            avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/userprofile%2F-1654005415331%2Favatar%2Favatar.png?alt=media&token=7570f367-29b1-4ae0-bbb7-36a6504d1967',
            lang:'pt',
            profile_picture:'https://liveplanet.app.br/assets/landingstyle/profile.png',
            status:0
        }
        this._companyService.updateProfile(user).then((res)=>{
          console.log('conta criada em users')

          this._appData.instagramUser=user;
          this._companyService.getCompanyWorkers(this.company).doc(uid).set(user).then(v=>{
            console.log('oncompany')
          })

          this._appData.profilePicture=user.profile_picture;
          let myuser=user;
          if (typeof window !== "undefined" && localStorage) {localStorage.setItem('instagramUser',JSON.stringify(myuser))}
          $('#registerSocialModal').modal('hide');
          let domain=window.location.origin
          window.location.replace(domain+"/welcome?1592880902713&room="+this.company.room);   
            
  

        });
      }).catch(
        (err)=>{
          console.log('falhooooo')

          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: this.translate.instant('GAME_USERLOGIN_COMPONENT_20'),
            confirmButtonColor: '#CFA349',
            confirmButtonText: 'OK'
          })
        }
      );
  

   
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/company-login/company-register.ts